import { DeprecatedApiService, OrganizationResource } from '@mode/legacy/data-access-model-js';
import { Resource } from '@mode/shared/util-halogen';

import { SamlIdentityResource } from '@mode/legacy/data-access-model-js';
import { SamlFormItem } from './identity-saml.component';

export class IdentitySamlService {
  static $inject = ['ApiService'];
  constructor(private api: DeprecatedApiService) {}

  //
  // Read and parse saml identity providers
  public getSamlProviders(samlIdentityCollection: Resource) {
    return this.api.getResource(samlIdentityCollection, 'saml_identity_providers');
  }

  public getSamlForms(samlIdentityCollection: Resource): angular.IPromise<SamlFormItem[]> {
    return this.getSamlProviders(samlIdentityCollection)
      .then((samlIdentity) => this.convertSamlProvidersToSamlForms(samlIdentity))
      .then((samlForms) => samlForms.reverse());
  }

  //
  // Create and parse saml identity providers
  public createNewSamlForm(organization: OrganizationResource): angular.IPromise<SamlFormItem> {
    return this.api
      .create<SamlIdentityResource>(organization, 'saml_identity_providers', {})
      .then((newSamlProvider) => this.convertToSamlProviderForm(newSamlProvider, false, true));
  }

  //
  // Destroy saml identity providers
  public destroySamlProvider(samlFormItem: SamlFormItem) {
    return this.api.destroy(samlFormItem.samlIdentity, {});
  }

  //
  // Update and parse saml identity providers
  public updateSamlProvider(samlFormItem: SamlFormItem, newFields) {
    return this.api
      .edit(samlFormItem.samlIdentity, newFields)
      .then((updatedSamlProvider) => this.convertToSamlProviderForm(updatedSamlProvider));
  }

  public toggleEnabledForSamlProvider(samlFormItem: SamlFormItem) {
    const newEnabledStatus = !samlFormItem.samlIdentity.enabled;
    return this.api
      .edit(samlFormItem.samlIdentity, {
        'saml_identity_provider.enabled': newEnabledStatus,
      })
      .then((updatedSamlProvider) => this.convertToSamlProviderForm(updatedSamlProvider));
  }

  //
  // Parsing and converter helpers
  public convertToSamlProviderForm(
    samlProvider: SamlIdentityResource,
    defaultCollapsed = true,
    defaultIsEditing = false
  ): SamlFormItem {
    return {
      samlIdentity: samlProvider,
      defaultCollapsed: defaultCollapsed,
      defaultIsEditing: defaultIsEditing,
    };
  }

  public convertSamlProvidersToSamlForms(samlProviders): SamlFormItem[] {
    return samlProviders.map((provider) => this.convertToSamlProviderForm(provider));
  }
}
